import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        usuerdata: {}
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            state.usuerdata = ''
            localStorage.setItem("userInfo", "");
        },
        userdata(state, data) {
            state.usuerdata = data

        }
    },
    actions: {
        userdatafu(context, data) {
            console.log(data, 'datadata');
            context.commit('userdata', data)
        }
    },
    plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/vuex/store.js